function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4295;enable-background:new    ;}\n\t.st1{opacity:0.1255;fill:#0D6D9E;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#D6DCE4;fill-opacity:0.75;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st1",
  width: 567.1,
  height: 302.6
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 283.5,
  cy: 151.3,
  r: 100
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Organization"
}, /*#__PURE__*/React.createElement("g", {
  id: "Release-detailed-view---tools",
  transform: "translate(-304.000000, -362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(260.000000, 240.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI_x2F_grey-icon-button",
  transform: "translate(30.000000, 111.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons_x2F_archive"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st3",
  d: "M226.3,200.4c0,4.5,3.7,8.2,8.2,8.2h98.1c4.5,0,8.2-3.7,8.2-8.2v-73.6H226.3V200.4z  M267.1,146.2c0-1.7,1.4-3.1,3.1-3.1h26.6c1.7,0,3.1,1.4,3.1,3.1v2c0,1.7-1.4,3.1-3.1,3.1h-26.6c-1.7,0-3.1-1.4-3.1-3.1 V146.2z M340.7,94.1H226.3c-4.5,0-8.2,3.7-8.2,8.2v12.3c0,2.2,1.8,4.1,4.1,4.1h122.7c2.2,0,4.1-1.8,4.1-4.1v-12.3 C348.9,97.7,345.3,94.1,340.7,94.1z"
}))))))));

function SvgArchiveAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.1 302.6",
    style: {
      enableBackground: "new 0 0 567.1 302.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveAssetTypeIcon);
export default __webpack_public_path__ + "static/media/archive-asset-type-icon.dbbd803e.svg";
export { ForwardRef as ReactComponent };